<template>
  <v-data-table
      :headers="headers1"
      :items="organizations"
      :items-per-page="itemsPerPage"
      item-key="organizationId"
      class="elevation-1"
      disable-sort-by
      dense
      :locale="systemLocale">
    <template v-slot:top>
      <v-row>
        <v-col class="pr-4 mr-3">
          <v-icon
              v-if="required"
              small
              left
              :color="requiredColor">
            *
          </v-icon>
        </v-col>
      </v-row>
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.organizationName="{ item }">
      {{ item.organizationName }}
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.isLocked="{ item }">
      <icon-tip
          :icon="item.isLocked
            ? 'lock'
            : 'lock_open'"
          :icon-color="item.isLocked
            ? 'error'
            : 'success'"
          :tip="$t('Текущий статус: {0}', [ $t(item.isLocked
            ? 'Заблокирована'
            : 'Активная') ] )" />
    </template>
    <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
    <template v-slot:item.prepaymentPercentage="{ item }">
      <!-- <v-row class="pb-1 pt-0 my-0">
        <v-col class="py-0 my-0"> -->
      <validatable-text-input
          v-if="!readonly"
          :key="`${item.OrganizationId}_prepayment`"
          v-model="item.prepaymentPercentage"
          v-test="{ input: 'prepaymentPercentage' }"
          :readonly="readonly"
          :rules="{ required: true,
                    min_value: 0,
                    max_value: 100,
                    regex: /^[0-9]{1,3}$/ }"
          :clearable="false"
          hide-details="auto"
          :tabindex="1"
          solo
          dense
          data-type="float"
          @change="change" />
      <!-- </v-col>
      </v-row> -->
      {{ readonly ? item.prepaymentPercentage : null }}
    </template>
  </v-data-table>
</template>

<script>
  import IconTip from './IconTip.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import { PARTICIPANT_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { ORGANIZATION_MANAGEMENT } from '@/constants/store.js'
  import lodash from 'lodash'

  export default {
    components: {
      IconTip,
      ValidatableTextInput
    },
    props: {
      value: {
        type: Array,
        default: () => {
          return []
        }
      },
      required: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      errorMessages: Array,
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        itemsPerPage: 10,
        organizations: [],
        params: {
          participantType: PARTICIPANT_TYPES.PARTICIPANT

        }
      }
    },
    computed: {
      ...mapState(ORGANIZATION_MANAGEMENT.NAMESPACE, {
        items: state => (state[ORGANIZATION_MANAGEMENT.STATE.SHORT_INFO_LIST] || [])
      }),
      headers1 () {
        return [
          { text: this.$t('Наименование организации'), sortable: true, value: 'organizationName' },
          { text: this.$t('Статус'), sortable: true, value: 'isLocked' },
          { text: this.label, sortable: true, value: 'prepaymentPercentage' }
        ]
      },
      filteredItems () {
        if (this.loading) {
          return []
        }
        let filteredItems = this.items || []
        if (!this.value.length) {
          // return filteredItems.filter(r => !r.isLocked)
        } else {
          const orgIds = this.value.map(o => o.organizationId)
          filteredItems = filteredItems.filter(org => orgIds.includes(org.organizationId))
        }

        return filteredItems.map(x => ({ ...x }))
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal, oldVal) {
          if ((newVal?.length === oldVal?.length &&
            newVal?.length === 0) ||
            this.items?.length === 0) {
            return
          }
          if (!lodash.isEqual(newVal, oldVal)) {
            this.mapSelected(newVal)
          }
        }
      },
      // items: {
      //   immediate: true,
      //   handler (newVal, oldVal) {
      //     if ((newVal?.length === oldVal?.length) ||
      //     newVal?.length === 0) {
      //       return
      //     }
      //     this.mapSelected(this.value)
      //   }
      // },
      loading: {
        immediate: true,
        handler (newVal, oldVal) {
          if (newVal || newVal === oldVal) {
            return
          }
          if (!this.items.length) {
            this.getOrganizationsShortInfoList()
          } else {
            this.mapSelected(this.value)
          }
        }
      }
    },
    created () {

    },
    methods: {
      ...mapActions(ORGANIZATION_MANAGEMENT.NAMESPACE, {
        getOrganizationsShortInfoListAction: ORGANIZATION_MANAGEMENT.ACTIONS.GET_ORGANIZATIONS_SHORT_INFO_LIST
      }),
      mapSelected: function (prepayments) {
        const vm = this
        if (!vm.filteredItems.length) {
          return
        }
        // первичная инициализация, если в родительском компоненте заданы значения по умолчанию
        // либо изменение входных данных после загрузки с сервера
        const orgIds = prepayments.map(o => o.organizationId)
        let needUpdate = false
        const organizations = vm.organizations.filter(org => orgIds.includes(org.organizationId))
        needUpdate = organizations.length !== vm.organizations.length ||
          organizations.length !== orgIds.length

        if (prepayments && prepayments.length) {
          prepayments.forEach(org => {
            let organization = organizations.find(i => i.organizationId === org.organizationId)
            if (!organization) {
              needUpdate = true
              organization = vm.filteredItems.find(i => i.organizationId === org.organizationId)
              organizations.push({
                ...organization,
                prepaymentPercentage: org.prepaymentPercentage
              })
            } else {
              organization.prepaymentPercentage = org.prepaymentPercentage
            }
          })
          vm.organizations = organizations
        } else {
          vm.organizations = vm.filteredItems
          needUpdate = true
        }
        if (needUpdate) {
          vm.change()
        }
      },
      change: function () {
        this.$emit('input', this.organizations.map(ps => ({
          organizationId: ps.organizationId,
          prepaymentPercentage: ps.prepaymentPercentage
        })))
      },
      getOrganizationsShortInfoList: async function () {
        try {
          this.isLoading = true
          await this.getOrganizationsShortInfoListAction(this.params)
          this.isLoading = false
          this.mapSelected(this.value)
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
